import React, {useEffect,useState} from 'react';
import { Text, Group, Button, Table, Anchor } from '@mantine/core';
import { modals } from '@mantine/modals';

export function PageList({
  SelectedPageCreateTests,
  SelectedThumbnail,
  SelectedThumbnailChange,
  SelectedDraftThumbnail,
  SelectedDraftThumbnailChange,
  DraftThumbnailIsSelected,
  DraftThumbnailIsSelectedChange,
  ThumbnailIsSelected,
  ThumbnailIsSelectedChange,
  SelectedDraftPageIdChange,
  SelectedDraftTaguchiIdChange,
  selectedAllCreateTestPageValue,
  setActiveTestsId,
  setActiveFunnelId,
  setIsActiveTestSelected
  }:any) {

  const [selectedPageMsg, setSelectedPageMsg] = useState("");
  const handleDraftThumbnailClick = (pageId,taguchiTestId,funnelId,testsId) => {
    if (DraftThumbnailIsSelected && SelectedDraftThumbnail === pageId) {
      SelectedDraftThumbnailChange(null);
      DraftThumbnailIsSelectedChange(false);
    } else {
      SelectedThumbnailChange(null);  
      SelectedDraftThumbnailChange(pageId);
      DraftThumbnailIsSelectedChange(true);
      SelectedDraftPageIdChange(pageId);
      SelectedDraftTaguchiIdChange(taguchiTestId);
    }
  };

  const handleThumbnailClick = (pageId,taguchiTestId,funnelId,testsId,pageClass) => {
    if (ThumbnailIsSelected && SelectedThumbnail === pageId) {
      SelectedThumbnailChange(null);
      ThumbnailIsSelectedChange(false);
    } else {
      SelectedThumbnailChange(pageId);
      ThumbnailIsSelectedChange(true);
      SelectedDraftThumbnailChange(null);  
      SelectedDraftTaguchiIdChange(taguchiTestId);
      setActiveTestsId(testsId);
      setActiveFunnelId(funnelId);
      if(pageClass === "page active"){
        setIsActiveTestSelected(true);
      }
    }
  };

  useEffect(() => {
    if (selectedPageMsg !== "") {
      modals.open({
        trapFocus: false,
        title: 'Message',
        children: (
        <>
          <Text size="sm" style={{ whiteSpace: "pre-line" }}>
            {selectedPageMsg.trim()}
          </Text>
          <Group position="right" mt="sm">
            <Button onClick={() => {modals.closeAll();setSelectedPageMsg("");}}>OK</Button>
          </Group>
        </>
        ),
      });
      return;
    }
  }, [selectedPageMsg]);

  return (
    <>
      {selectedAllCreateTestPageValue === "3" ? (
        <Table striped highlightOnHover withBorder withColumnBorders mb={10} style={{cursor: 'pointer'}}>
          <thead>
            <tr>
              <th style={{ width: 80 }}>Preview</th>
              <th style={{ width: 400 }}>URL</th>
              <th style={{ width: 400 }}>Page Title</th>
              <th style={{ width: 80 }}>Uniques</th>
              <th style={{ width: 60 }}>Visits</th>
              <th>Active Test name</th>
              <th>Test Type</th>
            </tr>
          </thead>
          <tbody>
            {SelectedPageCreateTests.map((item,index) => (
            <tr key={index} 
                style={{ backgroundColor: (item.selected || SelectedThumbnail === item.page_id || SelectedDraftThumbnail === item.page_id) ? '#00b975' : '',
                  transition: 'background-color 0.1s',
                  color: (item.selected || SelectedThumbnail === item.page_id) ? 'white' : 'inherit' 
                }} 
                onClick={item.selected ? undefined : () => {
                  if (item.page_class === "page draft" && (item.draft_test_type_name === "Single Variable Test" || item.draft_test_type_name === "Modern AB")) {
                      handleDraftThumbnailClick(item.page_id, item.taguchi_test_id, item.funnel_id, item.tests_id);
                  }else if(item.page_class === "page winner") {
                      setSelectedPageMsg("This page already has a winner.");
                  }else if(item.page_class === "page rotation") {
                      setSelectedPageMsg("This page is already being used as a rotation page.");
                  }else if(item.page_class === "page discarded_by_cron") {
                      setSelectedPageMsg("This page has been discarded automatically by the system.");
                  }else if(item.marge_img === "img/merged-icon.png") {
                      setSelectedPageMsg("You can't set up a test on a merged page.");
                  }else {
                      handleThumbnailClick(item.page_id, item.taguchi_test_id, item.funnel_id, item.tests_id, item.page_class);
                  }
                }}
            >
              <td><a href={item.page_url} target="_blank" rel="noreferrer" style={{color: (item.selected || SelectedThumbnail === item.page_id) ? 'white' : ''}}>Preview</a></td>
              <td><Text><Anchor href={item.page_url} target="_blank" color="inherit">{item.page_url}</Anchor></Text></td>
              <td><Text>{item.page_title}</Text></td>
              <td><Text>{item.uniques}</Text></td>
              <td><Text>{item.visits}</Text></td>
              <td><Text>{item.draft_test_name}</Text></td>
              <td><Text>{item.draft_test_type_name}</Text></td>
            </tr>
          ))}
          </tbody>
        </Table>
      ) : (
        <Table striped highlightOnHover withBorder withColumnBorders mb={10}>
          <thead>
            <tr>
              <th>URL</th>
              <th>Page Title</th>
              <th>Draft Test name</th>
              <th>Draft Test Type</th>
            </tr>
          </thead>
          <tbody>
            {SelectedPageCreateTests.map((item,index) => (
            <tr key={index} 
                style={{ backgroundColor: (item.selected || SelectedThumbnail === item.page_id || SelectedDraftThumbnail === item.page_id) ? '#00b975' : '',
                  transition: 'background-color 0.1s',
                  color: (item.selected || SelectedThumbnail === item.page_id) ? 'white' : 'inherit' 
                }} 
                onClick={item.selected ? undefined : () => {
                  if (item.draft_test_type_name === "Single Variable Test") {
                      handleDraftThumbnailClick(item.page_id, item.taguchi_test_id, item.funnel_id, item.tests_id);
                  } else if (item.draft_test_type_name === "Modern AB") {
                      handleDraftThumbnailClick(item.page_id, item.taguchi_test_id, item.funnel_id, item.tests_id);
                  } else {
                      handleThumbnailClick(item.page_id, item.taguchi_test_id, item.funnel_id, item.tests_id, "");
                  }
                }}
            >
              <td><a href={item.page_url} target="_blank" rel="noreferrer" style={{color: (item.selected || SelectedThumbnail === item.page_id) ? 'white' : ''}}>Preview</a></td>
              <td><Text><Anchor href={item.page_url} target="_blank" color="inherit">{item.page_url}</Anchor></Text></td>
              <td><Text>{item.draft_test_name}</Text></td>
              <td><Text>{item.draft_test_type_name}</Text></td>
            </tr>
          ))}
          </tbody>
        </Table> 
      )}
    </>
  );
}